import React, { useState } from "react";
import classes from "./LabDetailsLayout.module.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LabDetailsLayout = ({ sections, backLink }) => {
  const [activeSection, setActiveSection] = useState("details");
  const { user } = useAuth();
  const userRole = user?.role;

  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(backLink); // -1 navigates to the previous page
  };

  return (
    <div className={`${classes.wrapper} d-flex vh-100`}>
      {/* Only show sidebar if userRole is NOT LABORATORY */}
      {userRole !== "LABORATORY" && (
        <nav className={`${classes.sidebar}`}>
          <div
            className="d-flex align-items-center gap-2 mb-3"
            onClick={handleGoBack}
            role="button"
          >
            <FaArrowLeftLong style={{ flexShrink: 0 }} />
            <h4>Lab details</h4>
          </div>

          <ul className="nav flex-column gap-2 py-3">
            {sections.map((section, i) => (
              <li key={i} className="nav-link cursor-pointer m-0 p-0">
                <NavLink
                  to={section.link}
                  className={({ isActive }) =>
                    `d-flex align-items-center ${classes.navLink} ${
                      isActive ? classes.active : ""
                    }`
                  }
                >
                  {section.title}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}

      <div className={`${classes.labContent} flex-grow-1 overflow-auto`}>
        <Outlet />
      </div>
    </div>
  );
};

export default LabDetailsLayout;
